import { useContext, useEffect, useState } from "react";
import { OrderDetail } from "../../../../interfaces/interfaces";
import AuthenticationHOC from "../../../../components/AuthenticationHOC/AuthenticationHOC";
import { AlertContent } from "../../../../interfaces/interfaces";
import LoadingSpinner from "../../../../components/LoadingSpinner/LoadingSpinner";
import Toast from "../../../../components/Toast/Toast";
import { Wrapper } from "../../../../components/styled/styled-components";
import { Context, IContext } from "../../../../context/ContextApp";
import getOrder from "../../fetch/getOrder";
import { ResponseStatusTypes } from "./renders";
import { getPaymentMethodSession, IPaymentSessionResponse } from "../../fetch/paymentMethod";
import { subdomainTypes } from "../../../../context/availableSubdomains";
import OrderHistoryHeader from "./OrderHistoryHeader";
import OrderHistoryContent from "./OrderHistoryContent";

interface Props {
  orderId: number;
  orderAccpacNo: number;
  generateAuthHeader: any;
  order: OrderDetail;
  statusBadge: React.ReactNode;
  hasBackOrder: boolean;
}

function OrderHistoryDetails({
  generateAuthHeader,
  orderId,
  orderAccpacNo,
  order: orderProp,
  statusBadge,
  hasBackOrder,
}: Props) {
  const [orderStatus, setOrderStatus] = useState("");
  const [toast, setToast] = useState<AlertContent | null>(null);
  const { appBranch }: IContext = useContext(Context);
  const [order, setOrder] = useState<OrderDetail>();
  const [responseStatus, setResponseStatus] = useState<ResponseStatusTypes | null>(null);
  const [paymentSessionUrl, setPaymentSessionUrl] = useState<string | null>(null);

  useEffect(() => {
    const loadOrderStatus = async () => {
      if (orderProp.status.toLowerCase() === "invoiced") return setOrderStatus("Invoiced");

      const url = `${process.env.REACT_APP_HALFBACK_ROOT_API}/orders/order_status?order_accpac_no=${orderAccpacNo}`;

      const res = await fetch(url, generateAuthHeader());
      const data = await res.json();

      try {
        if (data.status === "success") {
          setOrderStatus(data.result.status);
        } else {
          setOrderStatus("Submitted");
        }
      } catch (error) {
        // if (error.response.status === "401") {
        //   alert("Your session is expired. Please login again.");
        //   return <Redirect to="/" />;
        // }

        setOrderStatus("Submitted");
      }
    };

    const loadOrder = async () => {
      const response = await getOrder(orderId);

      if (response.status === 200 && response.order) {
        setOrder(response.order);
      }
    };

    const loadPaymentSession = async () => {
      const redirection_url = `${window.location.origin}/order-history`;
      const responseSession: IPaymentSessionResponse = await getPaymentMethodSession(
        orderId,
        redirection_url,
      );
      if (responseSession.status === 200 && responseSession.session_url !== null) {
        setResponseStatus(ResponseStatusTypes.success_unpaid);
        setPaymentSessionUrl(responseSession.session_url);
        return;
      }
      if (responseSession.status === 200 && responseSession.session_url === null) {
        const paymentStatusAction = {
          unpaid: null,
          paid: ResponseStatusTypes.success_paid,
          unavailable: ResponseStatusTypes.success_unavailable,
          confirming: ResponseStatusTypes.success_confirming,
          default: ResponseStatusTypes.success_confirming,
        };
        const statusType = paymentStatusAction[responseSession.payment_status || "default"];

        setResponseStatus(statusType);
        return;
      }
    };

    const loadOrderInfo = async () => {
      await loadOrderStatus();
      await loadOrder();
      if (appBranch !== subdomainTypes.NZ) await loadPaymentSession();
    };

    if (!order && !orderStatus) loadOrderInfo();
  }, [generateAuthHeader, order, orderId, orderStatus, orderAccpacNo, appBranch, orderProp.status]);

  if (!order)
    return (
      <Wrapper style={{ padding: "10px" }}>
        <LoadingSpinner inline />
      </Wrapper>
    );

  return (
    <div className="store-order-detail">
      <OrderHistoryHeader
        order={order}
        orderProp={orderProp}
        statusBadge={statusBadge}
        hasBackOrder={hasBackOrder}
        orderId={orderId}
        responseStatus={responseStatus}
        paymentSessionUrl={paymentSessionUrl}
        setToast={setToast}
      />
      <OrderHistoryContent order={order} />
      <Toast content={toast} onClick={() => setToast(null)} />
    </div>
  );
}

export default AuthenticationHOC(OrderHistoryDetails);
